<template>

	<div class="wages wrapper shadow level-setting">

		<div class="operation">

			<div class="left">

				<div class="main-title">社保级别设置</div>

			</div>

			<div class="right">

				<span>变动日期：</span>

				<el-date-picker v-model="insurance.startDate" type="month" format="YYYY-MM" size="large"

					value-format="YYYY-MM-DD" placeholder="社保级别变动生效日期" />

			</div>

		</div>

		<div class="level-pane">

			<ul>

				<li v-for="(item, index) in levelList" :key="index">

					<div class="level-content">

						<div class="name">

							<el-input v-model="item.name" placeholder="名称" size="large">

							</el-input>

						</div>

						<div class="amount-row">

							<span>社保扣款总数：</span>

							<el-input v-model="item.amount" placeholder="社保扣款总数" size="large" type="number" step="0.01">

								<template #prepend>￥</template>

							</el-input>

						</div>

						<div class="breakdown-row">

							<span>养老保险：</span>

							<el-input v-model="item.pensionAmount" placeholder="养老保险扣款" size="large" type="number" step="0.01">

								<template #prepend>￥</template>

							</el-input>

						</div>

						<div class="breakdown-row">

							<span>医疗保险：</span>

							<el-input v-model="item.medicalAmount" placeholder="医疗保险扣款" size="large" type="number" step="0.01">

								<template #prepend>￥</template>

							</el-input>

						</div>

						<div class="breakdown-row">

							<span>失业保险：</span>

							<el-input v-model="item.unemploymentAmount" placeholder="失业保险扣款" size="large" type="number" step="0.01">

								<template #prepend>￥</template>

							</el-input>

						</div>

					</div>

					<el-button class="del-btn" type="danger" :icon="Delete" @click="delClick(index)"></el-button>

				</li>

			</ul>

			<div class="operate-btn">

				<el-button type="warning" @click="addClick" class="main-btn main-btn-warning add-btn">添加级别</el-button>

				<el-button type="primary" @click="saveClick" class="main-btn main-btn-primary save-btn">保存设置</el-button>

			</div>

		</div>

	</div>

</template>



<script setup>

	import {

		onMounted,

		ref

	} from "vue";

	import {

		Delete

	} from "@element-plus/icons-vue";

	import {

		ElMessage,

		ElMessageBox

	} from "element-plus";

	import {

		fetchLast,

		save

	} from "@/api/insureLevel";



	onMounted(() => {

		getInsurance();

	});

	const insurance = ref({});

	const levelList = ref([]);



	const getInsurance = () => {

		fetchLast().then((res) => {

			insurance.value = res.data

			levelList.value = insurance.value.insureLevels

		});

	}



	const parseAmount = (val) => {

		const num = parseFloat(val)

		return isNaN(num) ? 0 : num

	}



	// 添加一行

	const addClick = () => {

		levelList.value.push({

			id: '',

			name: '',

			amount: '',

			pensionAmount: '',

			medicalAmount: '',

			unemploymentAmount: '',

		});

	};

	// 删除一行

	const delClick = (index) => {

		levelList.value.splice(index, 1);

	};

	// 保存设置

	const saveClick = () => {
		let list = levelList.value
		for (const e of list) {
			if (!e.name) {
				ElMessage({
					type: "error",
					message: "请将数据填写完整！",
				});
				return
			}
			if (!e.amount && e.amount !== 0) {
				e.amount = 0
			}
			if (e.pensionAmount === '' || e.pensionAmount == null) {
				e.pensionAmount = 0
			}
			if (e.medicalAmount === '' || e.medicalAmount == null) {
				e.medicalAmount = 0
			}
			if (e.unemploymentAmount === '' || e.unemploymentAmount == null) {
				e.unemploymentAmount = 0
			}
			const total = parseAmount(e.amount)
			const breakdown = parseAmount(e.pensionAmount) + parseAmount(e.medicalAmount) + parseAmount(e.unemploymentAmount)
			if (Math.abs(breakdown - total) > 0.01) {
				ElMessage({
					type: "error",
					message: `级别【${e.name}】三项扣款之和必须等于社保扣款总数！`,
				});
				return
			}
		}
		insurance.value.insureLevels = levelList.value

		ElMessageBox.confirm("确定要保存设置吗?", "提示", {

				confirmButtonText: "确定",

				cancelButtonText: "取消",

				type: "warning",

			})

			.then(() => {

				save(insurance.value).then(() => {

					fetchLast()

					ElMessage({

						type: "success",

						message: "保存成功！",

					});

				})

			})

			.catch(() => {});

	};

</script>



<style lang="scss" scoped>

	.level-setting {

		.operation{

			.right{

				align-items: center;

			}

		}

		.level-pane {

			ul {

				display: flex;

				flex-wrap: wrap;

				justify-content: space-between;



				li {

					width: 48%;

					display: flex;

					align-items: flex-start;

					justify-content: space-between;

					background: #e0f2ff;

					padding: 10px;

					margin: 0 0 10px 0;



					.level-content {

						flex: 1;

						margin-right: 10px;

					}



					.name {

						margin-bottom: 8px;

					}



					.amount-row,

					.breakdown-row {

						display: flex;

						align-items: center;

						margin-bottom: 6px;



						span {

							white-space: nowrap;

							width: 110px;

							text-align: right;

							margin-right: 8px;

							font-size: 14px;

						}



						::v-deep .el-input {

							flex: 1;



							.el-input__inner {

								font-size: 16px;

								font-weight: bold;

								color: $main-color;



								&::placeholder {

									font-size: 14px;

									font-weight: normal;

								}

							}

						}

					}



					.del-btn {

						margin-top: 4px;

						padding: 8px 10px;

						font-size: 18px;

					}

				}

			}

		}



		.operate-btn {

			margin: 10vh auto 0;

			width: fit-content;



			.save-btn {

				width: 240px;

			}

		}

	}



	@media (max-width:1200px) {

		.level-pane {

			li {

				width: 100% !important;

			}

		}

	}

</style>


